// ─── Route path constants ───────────────────────────────────────────────────
// Extracted into its own file to avoid circular dependencies between
// router.tsx (which imports layout components) and layout components
// (which need ROUTES for NavLink / useNavigate).

export const ROUTES = {
  landing: '/',
  login: '/login',
  dashboard: '/dashboard',
  synapse: '/synapse',
  brain: '/brain',
  tasks: '/taches',
  calendar: '/calendrier',
  events: '/evenements',
  notes: '/notes',
  goals: '/objectifs',
  contacts: '/contacts',
  habits: '/habitudes',
  domains: '/domaines',
  months: '/mois',
  finances: '/finances',
  kanban: '/kanban',
  gantt: '/gantt',
  roadmap: '/roadmap',
  timeline: '/timeline',
  feedback: '/feedback',
  settings: '/settings',
  subscription: '/abonnement',
  parametres: '/parametres',
  mentionsLegales: '/mentions-legales',
  cgu: '/cgu',
  cgv: '/cgv',
  confidentialite: '/confidentialite',
} as const;
